// extracted by mini-css-extract-plugin
export var card = "_ad-1";
export var container = "_ad-0";